<template>
    <a v-if="!type" class="Button" :href="href" :class="[
      { 'Button--default': !isPrimary && !isLink },
      { 'Button--primary': isPrimary },
      { 'Button--link': isLink },
      { 'Button--inverse': isInverse },
      { 'Button--block': isBlock },
      { [`Button--${size}`]: !!size }
    ]" >
        <span class="Button-inner">
            <span class="Button-label">
                {{label}}
            </span>
            <icon class="Button-icon" :name="icon"/>
        </span>
    </a>

    <button v-else class="Button" :class="[
      { 'Button--default': !isPrimary && !isLink },
      { 'Button--primary': isPrimary },
      { 'Button--link': isLink },
      { 'Button--inverse': isInverse },
      { 'Button--block': isBlock },
      { [`Button--${size}`]: !!size }
    ]" :type="type">
        <span class="Button-inner">
            <span class="Button-label">
                {{label}}
            </span>
        </span>
    </button>
</template>

<script>
import Icon from './Icon.vue';

export default {
  components: { Icon },
  props: {
    type: {
      type: String,
      default: null
    },
    href: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: 'double-arrow-right'
    },
    label: {
      type: String,
      default: ''
    },
    isPrimary: {
      type: Boolean,
      default: false
    },
    isLink: {
      type: Boolean,
      default: false
    },
    isInverse: {
      type: Boolean,
      default: false
    },
    isBlock: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
  }
}
</script>